import { Component, Input, Output, EventEmitter, OnChanges, OnInit, DoCheck, KeyValueDiffers } from '@angular/core';

export interface IPage {
    label: string;
    value: any;
}

export class ClickEvent {
    value:string;// next, previous,change-page
    index:number;

}

@Component({
    selector: 'pagination',
    template: `<nav class="navbar navbar-light bg-light navi" *ngIf="items.length > 0 || totalNbRespondents != null">
	<ul class="pagination">
			<li class="page-item" [class.disabled]="!previousEnabled">
				<a class="page-link hand" (click)="previous()" aria-label="Previous">
					<span aria-hidden="true"><i class="fas fa-chevron-left"></i></span>
				</a>
			</li>
			<li class="page-item" style="" [class.active]="currentIndex == page.value" *ngFor="let page of pages" (click)="changePage(page)">
				<a class="page-link hand">{{ page.label }}</a>
			</li>
			<li class="page-item" style="" [class.disabled]="!nextEnabled">
				<a class="page-link hand" (click)="next()" aria-label="Next">
					<span aria-hidden="true"><i class="fas fa-chevron-right"></i></span>
				</a>
			</li>
        <li style="display: inline-block"><input class="form-control mr-sm-1" type="search" placeholder="{{currentIndex}}" aria-label="Page" style="width:60px;" [(ngModel)]="_wantedPage"></li>
        <li style="display: inline-block"><button  type="button" class="btn btn-outline-primary" style="" (click)="onGoClick()">GO</button></li>
    </ul>
    </nav>
`,
    styles: [
        `.navbar{width: fit-content;}
    `
    ]
})
export class PaginationComponent implements OnChanges, DoCheck,OnInit {
    @Input() items = [];
    @Input() indexSelectedItem = 1;
    @Input('item-can-change') itemCanChange = false;
    @Input('max-size') maxSize = 10;
    @Input('item-by-page') itemByPage = 1;
    private nextEnabled = false;
    private previousEnabled = false;
    @Input('resp-by-list') byList = false;
    @Input('total-nb-respondents') totalNbRespondents:number = null;
    @Output() pageChanged = new EventEmitter<number>();
    @Output() beforePageChange = new EventEmitter();
    @Output() go = new EventEmitter();
    pages: IPage[] = [];
    currentIndex = 1;

    private _wantedPage:number;

    differ: any;

    constructor(private differs: KeyValueDiffers) {
        this.differ = differs.find({}).create(); // angular 5 change

    }

    ngDoCheck() {
        const changes = this.differ.diff(this.items);
        if (changes) {
            this.currentIndex = this.indexSelectedItem;
            this.updatePageLinks();
        } else {
            //  console.log('nothing changed');
        }

    }

    ngOnChanges() {
        this.currentIndex = this.indexSelectedItem;
        this.updatePageLinks();
        this.previousEnabled = ((this.currentIndex>1) &&(this.currentIndex<=this.pages.length));
        this.nextEnabled = ((this.currentIndex <(this.pages.length)));
    }

    ngOnInit() {
        this.updatePageLinks();
        this.previousEnabled = ((this.currentIndex>1) &&(this.currentIndex <=this.pages.length));
        this.nextEnabled = ((this.currentIndex <(this.pages.length)));
    }

    changePage(page: IPage) {
        if (this.itemCanChange) {
            const ce = new ClickEvent();
            ce.value = 'change-page';
            ce.index = page.value;
            this.beforePageChange.emit(ce);
        } else {
            this.pageChanged.emit(page.value);
            this.currentIndex = page.value;
            this.updatePageLinks();
        }
    }

    previous() {
        /*if (this.currentIndex == 1)
            return;*/

        if (this.itemCanChange) {
            const ce = new ClickEvent();
            ce.value = 'previous';
            ce.index = this.currentIndex - 1;
            this.beforePageChange.emit(ce);
        } else {
            this.currentIndex--;
            this.pageChanged.emit(this.currentIndex);
            this.updatePageLinks();
        }
    }

    next() {
        /*if (this.currentIndex == this.items.length)
            return;*/

        if (this.itemCanChange) {
            const ce = new ClickEvent();
            ce.value = 'next';
            ce.index = this.currentIndex + 1;

            const tmp = Math.ceil(this.totalNbRespondents / this.itemByPage);
            if(this.currentIndex !== tmp) {
                this.beforePageChange.emit(ce);
            }
        } else {
            this.currentIndex++;
            this.pageChanged.emit(this.currentIndex);
            this.updatePageLinks();
        }
    }


    onGoClick() {
        const total = Math.ceil(this.items.length / this.itemByPage);
        if(this._wantedPage <= total ) {
            const ce = new ClickEvent();
            ce.index = this._wantedPage;
            this.go.emit(ce);
        }
    }

    /**
 * Updates the page links and checks that the current page is valid. Should run whenever the
 * PaginationService.change stream emits a value matching the current ID, or when any of the
 * input values changes.
 */
    protected updatePageLinks() {
        if( this.totalNbRespondents != null) {
            this.pages = this.createPageArray(this.currentIndex, this.itemByPage, this.totalNbRespondents, this.maxSize);
        } else {

            this.pages = this.createPageArray(this.currentIndex, this.itemByPage, this.items.length, this.maxSize);
        }

    }

    protected createPageArray(currentPage: number, itemsPerPage: number, totalItems: number, paginationRange: number): IPage[] {
        const pages = [];
        let totalPages = Math.ceil(totalItems / itemsPerPage);
        if((totalPages*itemsPerPage)<totalItems) {
            const tmp = totalItems-(totalPages*itemsPerPage);
            if(tmp>0) {
                totalPages++;
            }
        }
        const halfWay = Math.ceil(paginationRange / 2);

        const isStart = currentPage <= halfWay;
        const isEnd = totalPages - halfWay < currentPage;
        const isMiddle = !isStart && !isEnd;

        const ellipsesNeeded = paginationRange < totalPages;
        let i = 1;

        while (i <= totalPages && i <= paginationRange) {
            let label;
            const pageNumber = this.calculatePageNumber(i, currentPage, paginationRange, totalPages);
            const openingEllipsesNeeded = (i === 2 && (isMiddle || isEnd));
            const closingEllipsesNeeded = (i === paginationRange - 1 && (isMiddle || isStart));
            if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
                label = '...';
            } else {
                label = pageNumber;
            }
            pages.push({
                label: label,
                value: pageNumber
            });
            i++;
        }
        return pages;
    }

    /**
     * Given the position in the sequence of pagination links [i],
     * figure out what page number corresponds to that position.
     */
    protected calculatePageNumber(i: number, currentPage: number, paginationRange: number, totalPages: number) {
        const halfWay = Math.ceil(paginationRange / 2);
        if (i === paginationRange) {
            return totalPages;
        } else if (i === 1) {
            return i;
        } else if (paginationRange < totalPages) {
            if (totalPages - halfWay < currentPage) {
                return totalPages - paginationRange + i;
            } else if (halfWay < currentPage) {
                return currentPage - halfWay + i;
            } else {
                return i;
            }
        } else {
            return i;
        }
    }
}
